import React, { lazy } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon, MessageCircleIcon } from 'lucide-react';
const ContactPage = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-395">
      {/* Header */}
      <section className="bg-blue-600 text-white py-12" data-id="element-396">
        <div className="container mx-auto px-4" data-id="element-397">
          <h1 className="text-3xl font-bold mb-4" data-id="element-398">Contact Us</h1>
          <p className="text-xl max-w-2xl" data-id="element-399">
            Have questions or need assistance? We're here to help. Reach out to
            our friendly support team.
          </p>
        </div>
      </section>
      {/* Contact Information */}
      <section className="py-12" data-id="element-400">
        <div className="container mx-auto px-4" data-id="element-401">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-402">
            {/* Contact Form */}
            <div className="bg-white rounded-xl shadow-sm p-8" data-id="element-403">
              <h2 className="text-2xl font-bold mb-6" data-id="element-404">Send Us a Message</h2>
              <form data-id="element-405">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-406">
                  <div data-id="element-407">
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-408">
                      Name
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Your name" data-id="element-409" />
                  </div>
                  <div data-id="element-410">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-411">
                      Email
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Your email address" data-id="element-412" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-413">
                  <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-414">
                    Subject
                  </label>
                  <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="What is your message about?" data-id="element-415" />
                </div>
                <div className="mb-6" data-id="element-416">
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-417">
                    Message
                  </label>
                  <textarea id="message" rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="How can we help you?" data-id="element-418"></textarea>
                </div>
                <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md font-medium" data-id="element-419">
                  Send Message
                </button>
              </form>
            </div>
            {/* Contact Info */}
            <div data-id="element-420">
              <div className="bg-white rounded-xl shadow-sm p-8 mb-8" data-id="element-421">
                <h2 className="text-2xl font-bold mb-6" data-id="element-422">Contact Information</h2>
                <div className="space-y-4" data-id="element-423">
                  <div className="flex items-start" data-id="element-424">
                    <MailIcon className="h-6 w-6 text-blue-600 mr-3 mt-0.5" data-id="element-425" />
                    <div data-id="element-426">
                      <h3 className="font-semibold" data-id="element-427">Email Us</h3>
                      <p className="text-gray-600" data-id="element-428">support@markethub.com</p>
                      <p className="text-gray-600" data-id="element-429">
                        sellers@markethub.com (For Seller Support)
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-430">
                    <PhoneIcon className="h-6 w-6 text-blue-600 mr-3 mt-0.5" data-id="element-431" />
                    <div data-id="element-432">
                      <h3 className="font-semibold" data-id="element-433">Call Us</h3>
                      <p className="text-gray-600" data-id="element-434">+1 (800) 123-4567</p>
                      <p className="text-gray-600 text-sm" data-id="element-435">
                        Monday-Friday, 9AM-6PM EST
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-436">
                    <MapPinIcon className="h-6 w-6 text-blue-600 mr-3 mt-0.5" data-id="element-437" />
                    <div data-id="element-438">
                      <h3 className="font-semibold" data-id="element-439">Our Office</h3>
                      <p className="text-gray-600" data-id="element-440">
                        123 Market Street, Suite 400
                        <br data-id="element-441" />
                        San Francisco, CA 94105
                        <br data-id="element-442" />
                        United States
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-443">
                    <ClockIcon className="h-6 w-6 text-blue-600 mr-3 mt-0.5" data-id="element-444" />
                    <div data-id="element-445">
                      <h3 className="font-semibold" data-id="element-446">Business Hours</h3>
                      <p className="text-gray-600" data-id="element-447">
                        Monday-Friday: 9:00 AM - 6:00 PM EST
                        <br data-id="element-448" />
                        Saturday: 10:00 AM - 4:00 PM EST
                        <br data-id="element-449" />
                        Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 rounded-xl p-6 border border-blue-100" data-id="element-450">
                <div className="flex items-center mb-4" data-id="element-451">
                  <MessageCircleIcon className="h-6 w-6 text-blue-600 mr-3" data-id="element-452" />
                  <h3 className="font-semibold text-lg" data-id="element-453">Live Chat Support</h3>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-454">
                  Need immediate assistance? Our live chat support is available
                  during business hours for quick help.
                </p>
                <button className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md font-medium" data-id="element-455">
                  Start Chat
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-12 bg-white" data-id="element-456">
        <div className="container mx-auto px-4" data-id="element-457">
          <div className="text-center mb-10" data-id="element-458">
            <h2 className="text-3xl font-bold mb-4" data-id="element-459">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-460">
              Find quick answers to common questions
            </p>
          </div>
          <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-461">
            <div data-id="element-462">
              <h3 className="font-semibold text-lg mb-3" data-id="element-463">
                How do I track my order?
              </h3>
              <p className="text-gray-600" data-id="element-464">
                You can track your order by logging into your account and
                visiting the "My Orders" section. There you'll find tracking
                information for all your recent purchases.
              </p>
            </div>
            <div data-id="element-465">
              <h3 className="font-semibold text-lg mb-3" data-id="element-466">
                What is your return policy?
              </h3>
              <p className="text-gray-600" data-id="element-467">
                We offer a 30-day return policy on most items. Products must be
                in their original condition with tags attached and original
                packaging.
              </p>
            </div>
            <div data-id="element-468">
              <h3 className="font-semibold text-lg mb-3" data-id="element-469">
                How do I become a seller?
              </h3>
              <p className="text-gray-600" data-id="element-470">
                Visit our "Become a Seller" page to learn about our seller
                program and submit an application. Our team will review your
                application and get back to you within 2-3 business days.
              </p>
            </div>
            <div data-id="element-471">
              <h3 className="font-semibold text-lg mb-3" data-id="element-472">
                Do you ship internationally?
              </h3>
              <p className="text-gray-600" data-id="element-473">
                Yes, we ship to over 100 countries worldwide. Shipping rates and
                delivery times vary by location. You can see specific shipping
                options during checkout.
              </p>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-474">
            <a href="/faq" className="text-blue-600 font-medium hover:underline" data-id="element-475">
              View all FAQs
            </a>
          </div>
        </div>
      </section>
      {/* Map */}
      <section className="py-12" data-id="element-476">
        <div className="container mx-auto px-4" data-id="element-477">
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-478">
            <div className="h-96 w-full" data-id="element-479">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0968478573097!2d-122.39901532357734!3d37.79129771201492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085806285ddb1b3%3A0x7b0f91824e50e1f0!2s123%20Market%20St%2C%20San%20Francisco%2C%20CA%2094105%2C%20USA!5e0!3m2!1sen!2suk!4v1690214180384!5m2!1sen!2suk" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" title="MarketHub Office Location" data-id="element-480"></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default ContactPage;